export default __webpack_public_path__ + "static/media/6.ee07fb5b.pdf";